<template>
	<thead>
		<tr class="rounded">
			<template v-for="th in thead">
				<th :key="'th-' + th.name" v-if="userColumns.includes(th.name)">
					<span v-if="th.sort" role="button" @click="setOrderBy(th.name)">
						{{ th.label }}
						<span v-if="orderBy === th.name">
							<font-awesome-icon
								v-if="direction === 'asc'"
								:icon="['fas', 'arrow-circle-up']"
								class="me-1"
							/>
							<font-awesome-icon
								v-if="direction === 'desc'"
								:icon="['fas', 'arrow-circle-down']"
								class="me-1"
							/>
						</span>
					</span>
					<span v-else>
						{{ th.label }}
					</span>
				</th>
			</template>
		</tr>
	</thead>
</template>

<script>
export default {
	name: 'LPDataTableThead',
	props: ['thead', 'userColumns'],
	data() {
		return {
			orderBy: this.$route.query.orderBy || 'id',
			direction: this.$route.query.direction || 'asc',
		}
	},
	created() {},
	updated() {},
	methods: {
		// Set direction
		setOrderBy(field) {
			if (this.orderBy === field && this.direction === 'asc') {
				this.direction = 'desc'
			} else {
				this.orderBy = field
				this.direction = 'asc'
			}

			this.$emit('setOrder', { orderBy: this.orderBy, direction: this.direction })
		},
	},
}
</script>
